import { useNavigate } from "react-router-dom";
import { LoginScreen } from "@rammetec/design-system/templates";
import { authService } from "@/authService";

export function LoginPage() {
  const navigate = useNavigate();

  return (
    <LoginScreen
      gradient
      brandName="VectorHub"
      brandLogo={<img src="/favicon.svg" alt="VectorHub" />}
      title="Entrar"
      submitLabel="Entrar"
      submittingLabel="Entrando…"
      monitorName="vectorhub.auth.login"
      onSubmit={async ({ email, password }) => {
        try {
          await authService.login(email, password, false);
          navigate("/");
        } catch (err) {
          const code = (err as { code?: string }).code;
          if (
            code === "auth/invalid-credential" ||
            code === "auth/wrong-password" ||
            code === "auth/user-not-found"
          ) {
            throw new Error(
              "Credenciais inválidas. Verifique seu e-mail e senha.",
            );
          }
          throw new Error("Falha no login. Tente novamente em instantes.");
        }
      }}
      onForgotPassword={() => navigate("/reset-password")}
    />
  );
}
